export enum ParentEntityType {
  Project = "PROJECT",
  Measurement = "MEASUREMENT",
}
